import React from 'react';
import { Box, Typography, Button, Paper, CircularProgress } from '@mui/material';
import { BarChart, ErrorOutline, HelpOutline } from '@mui/icons-material';
import { useBrand } from '../context/BrandContext';
import { useNavigate } from 'react-router-dom';

const AnalyticsPage = () => {
  const { activeBrandData, loading } = useBrand();
  const navigate = useNavigate();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!activeBrandData?.powerBiUrl) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          minHeight: '70vh',
          textAlign: 'center',
          p: 3
        }}
      >
        <Paper elevation={0} sx={{ p: 4, borderRadius: 4, border: '1px dashed', borderColor: 'divider', maxWidth: 600 }}>
          <BarChart sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Analytics BI não configurado
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Ainda não há um Dashboard do Power BI configurado para esta marca. 
            Você pode adicionar a URL nas configurações para começar a visualizar suas métricas profundas.
          </Typography>
          <Button 
            variant="contained" 
            onClick={() => navigate('/brand-settings')}
            startIcon={<HelpOutline />}
          >
            Configurar Dashboard
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: 'calc(100vh - 84px)', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BarChart color="primary" />
          Analytics & Business Intelligence - {activeBrandData.name}
        </Typography>
      </Box>
      <Box sx={{ flexGrow: 1, width: '100%', overflow: 'hidden' }}>
        <iframe
          title={`PowerBI-${activeBrandData.name}`}
          width="100%"
          height="100%"
          src={activeBrandData.powerBiUrl}
          frameBorder="0"
          allowFullScreen={true}
          style={{ border: 'none' }}
        />
      </Box>
    </Box>
  );
};

export default AnalyticsPage;
